import React from 'react';

export default () => {

    return (
        <>
            <div id="privacy">
                <div className="m-w-1000 mt-5 mb-5">
                    <h3 className="mt-2 mb-3">プライバシーポリシー</h3>
                    <h4 className="mt-2">基本方針</h4>
                    <p>当サイトは、個人情報の重要性を認識し、個人情報を保護することが社会的責務であると考え、個人情報に関する法令を遵守し、当サイトで取扱う個人情報の取得、利用、管理を適正に行います。</p>
                    <h4 className="mt-2">適用範囲</h4>
                    <p>本プライバシーポリシーは、お客様の個人情報もしくはそれに準ずる情報を取り扱う際に、当サイトが遵守する方針を示したものです。</p>
                    <h4 className="mt-2">個人情報の利用目的</h4>
                    <p>当サイトは、お客様からご提供いただく情報を以下の目的の範囲内において利用します。</p>
                    <ul >
                        <li>ご本人確認のため</li>
                        <li>お問い合せ等の確認・回答のため</li>
                        <li>各種お知らせ等の配信・送付のため</li>
                        <li>サービスの提供・改善・開発・マーケティングのため</li>
                        <li>お客さまの承諾・申込みに基づく、提携事業者・団体等への個人情報の提供のため</li>
                        <li>利用規約等で禁じている行為などの調査のため</li>
                        <li>その他個別に承諾いただいた目的</li>
                    </ul>
                    <h4 className="mt-2">個人情報の管理</h4>
                    <p>当サイトは、個人情報の正確性及び安全確保のために、セキュリティ対策を徹底し、個人情報の漏洩、改ざん、不正アクセスなどの危険については、必要かつ適切なレベルの安全対策を実施します。</p>
                    <p>当サイトは、第三者に重要な情報を読み取られたり、改ざんされたりすることを防ぐために、SSLによる暗号化を使用しております。</p>
                    <h4 className="mt-2">個人情報の第三者提供</h4>
                    <p>当サイトは、以下を含む正当な理由がある場合を除き、個人情報を第三者に提供することはありません。</p>
                    <ul >
                        <li>ご本人の同意がある場合</li>
                        <li>法令に基づく場合</li>
                        <li>人の生命・身体・財産の保護に必要な場合</li>
                        <li>公衆衛生・児童の健全育成に必要な場合</li>
                        <li>国の機関等の法令の定める事務への協力の場合（税務調査、統計調査等）</li>
                    </ul>
                    <p>当サイトでは、利用目的の達成に必要な範囲内において、他の事業者へ個人情報を委託することがあります。</p>
                    <h4 className="mt-2">個人情報に関するお問い合せ</h4>
                    <p>開示、訂正、利用停止等のお申し出があった場合には、所定の方法に基づき対応致します。具体的な方法については、個別にご案内しますので、お問い合せください。</p>
                    <h4 className="mt-2">Cookie（クッキー）</h4>
                    <p>Cookie（クッキー）は、利用者のサイト閲覧履歴を、利用者のコンピュータに保存しておく仕組みです。</p>
                    <p>利用者はCookie（クッキー）を無効にすることで収集を拒否することができますので、お使いのブラウザの設定をご確認ください。ただし、Cookie（クッキー）を拒否した場合、当サイトのいくつかのサービス・機能が正しく動作しない場合があります。</p>
                    <h4 className="mt-2">アクセス解析</h4>
                    <p>当サイトでは、サイトの分析と改善のためにGoogleが提供している「Google アナリティクス」を利用しています。</p>
                    <p>このサービスは、トラフィックデータの収集のためにCookie（クッキー）を使用しています。トラフィックデータは匿名で収集されており、個人を特定するものではありません。</p>
                    <p>Cookie（クッキー）を無効にする方法に関する詳細は、https://policies.google.com/technologies/ads?gl=jp をご覧ください。</p>
                    <h4 className="mt-2">お問い合せフォーム</h4>
                    <p>当サイトでは、お問い合せフォームに表示されているデータ等を収集します。</p>
                    <h4 className="mt-2">免責事項</h4>
                    <p>当サイトのコンテンツ・情報について、可能な限り正確な情報を掲載するよう努めておりますが、正確性や安全性を保証するものではありません。当サイトに掲載された内容、または利用した結果によって生じた損害等の一切の責任を負いかねますのでご了承ください。</p>
                    <p>当サイトからリンクやバナーなどによって他のサイトに移動した場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。</p>
                    <h4 className="mt-2">著作権・肖像権</h4>
                    <p>当サイトで掲載しているすべてのコンテンツ（文章、画像、動画、音声、ファイル等）の著作権・肖像権等は当サイト所有者または各権利所有者が保有し、許可なく無断利用（転載、複製、譲渡、二次利用等）することを禁止します。また、コンテンツの内容を変形・変更・加筆修正することも一切認めておりません。</p>
                    <p>各権利所有者におかれましては、万一掲載内容に問題がございましたら、ご本人様よりお問い合せください。迅速に対応いたします。</p>
                    <h4 className="mt-2">リンク</h4>
                    <p>当サイトは原則リンクフリーです。リンクを行う場合の許可や連絡は不要です。引用する際は、引用元の明記と該当ページへのリンクをお願いします。</p>
                    <p>ただし、画像ファイルへの直リンク、インラインフレームを使用したHTMLページ内で表示する形でのリンクはご遠慮ください。</p>
                    <h4 className="mt-2">本プライバシーポリシーの変更</h4>
                    <p>当サイトは、本プライバシーポリシーの内容を適宜見直し、その改善に努めます。</p>
                    <p>本プライバシーポリシーは、事前の予告なく変更することがあります。</p>
                    <p>本プライバシーポリシーの変更は、当サイトに掲載された時点で有効になるものとします。</p>
                    <p>以上</p>
                </div>
            </div>
        </>
    );
};